import { Typography } from '@mui/material';
import { CustomPDFViewer } from 'components/CustomPDFViewer';
import React from 'react';

type Props = {
  url: string;
  hideDownload?: boolean;
  scale?: number;
  fileName?: string;
  from?: string;
  analyticalCandidateName?: string;
  candidateId?: string;
  lastUpdated?: string;
};

export const PdfViewer: React.FC<Props> = (props: Props) => {
  const {
    analyticalCandidateName,
    hideDownload,
    candidateId,
    from,
    fileName,
    lastUpdated,
    url,
  } = props;

  return (
    <Typography component={'div'}>
      <div className="pdf-app-views pdf-app-views-new-viewer">
        <div className="pdf-page-container pdf-page-container-new-viewer">
          <CustomPDFViewer
            analyticalCandidateName={analyticalCandidateName}
            candidateId={candidateId}
            fileUrl={url}
            fileName={fileName}
            from={from}
            hideDownload={hideDownload}
            lastUpdated={lastUpdated}
          />
        </div>
      </div>
    </Typography>
  );
};
